<template>
  <div class="foot">
    <footer class="footer">
      <div class="footerpo">
        <div class="footBox">
          <Row class="foot_main">
            <Col span="12" class="foot_l">
              <ul class="foot_link">
                <li class="iwo">
                  <a href="http://www.le.cn/" target="_Blank"></a>
                </li>
                <li class="line"></li>
                <li class="youming">
                  <a href="https://www.62.com/" target="_Blank"></a>
                </li>
                <li class="line"></li>
                <li class="chaomi">
                  <a href="https://www.chaomi.cc/" target="_Blank"></a>
                </li>
                <li class="line"></li>
                <li class="SZDA">
                  <a href="http://www.szda.cn/" target="_Blank"></a>
                </li>
              </ul>
              <ul class="aboutus">
                <li>
                  <span></span>
                  <span>{{$t('title.w10')}}</span>
                </li>
                <li>
                  <router-link :to="{name:'notice'}">{{$t('nav.w32')}}</router-link>
                </li>
                <li>
                  <router-link :to="{name:'news'}">{{$t('nav.w33')}}</router-link>
                </li>
                <li>
                  <router-link :to="{name:'webStated'}">{{$t('nav.w34')}}</router-link>
                </li>
                <li>
                  <router-link :to="{name:'about'}">{{$t('nav.w35')}}</router-link>
                </li>
              </ul>
              <ul class="help">
                <li>
                  <span></span>
                  <span>{{$t('title.w11')}}</span>
                </li>
                <li>
                  <router-link :to="{name:'help'}">{{$t('nav.w36')}}</router-link>
                </li>
                <li>
                  <router-link :to="{name:'helpdetail',params:{id:LoanHelpItemId}}">{{$t('nav.w5')}}</router-link>
                </li>
                <li>
                  <router-link
                    :to="{name:'helpdetail',params:{id:InvestHelpItemId}}"
                  >{{$t('nav.w4')}}</router-link>
                </li>
              </ul>
            </Col>
            <Col span="12" class="foot_r">
              <div class="fr footer-right">
                <div class="clearfix">
                  <div class="telphone fl">
                    <img src="../assets/footer_tel.png" alt />
                  </div>
                  <div class="phone_num fl">
                    <p>（+86）400-886-3306</p>
                    <p>{{$t('other.w33')}}</p>
                  </div>
                </div>
                <div class="tip">{{$t('other.w34')}}</div>
              </div>
            </Col>
          </Row>
          <div class="line_copy" v-if="false">
            <p class="line"></p>
            <p class="copy">&copy; {{$t('other.w35')}}</p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      LoanHelpItemId: "",
      InvestHelpItemId: ""
    };
  },
  created() {
    this.getId();
  },
  methods: {
    getId() {
      this.$axios
        .get("/Member/RZJInfoCenter/HelpCenterLoanAndInvest")
        .then(res => {
          if (res.err) return res.throw();
          this.LoanHelpItemId = res.LoanHelpItemId;
          this.InvestHelpItemId = res.InvestHelpItemId;
        });
    }
  },
  watch: {
    lang() {
      this.getId();
    }
  },
  computed: {
    lang() {
      return this.$i18n.locale;
    }
  }
};
</script>

<style lang="less" scoped>
.foot {
  width: 100%;
  height: 260px;
  color: rgba(255, 255, 255, 1);
  background: rgba(46, 61, 92, 1);
  .footerpo {
    position: relative;
    margin: 0 auto;
    height: 260px;
    .footBox {
      background-size: 100%;
      width: 100%;
      height: 100%;
      width: 1200px;
      min-width: 980px;
      margin: 0 auto;
      .foot_l {
        .foot_link {
          margin: 53px 0;
          height: 20px;
          li {
            height: 20px;
            float: left;
            a {
              display: block;
              height: 20px;
              background: url("../assets/footer_link.png") left no-repeat;
              opacity: 0.6;
            }
          }
          .iwo {
            width: 98px;
            a {
              background-position: 15px -81px;
              background-size: 100%;
            }
          }
          .youming {
            width: 98px;
            margin-left: 30px;
            a {
              background-position: 0 -20px;
              background-size: 100%;
            }
          }
          .chaomi {
            width: 98px;
            margin-right: 12px;
            margin-left: 30px;
            a {
              background-position: 0 -40px;
              background-size: 100%;
            }
          }
          .SZDA {
            width: 98px;
            margin-left: 30px;
            a {
              background-position: 0 -60px;
              background-size: 100%;
            }
          }
          .line {
            width: 1px;
            height: 20px;
            background: rgba(255, 255, 255, 1);
            opacity: 0.2;
          }
        }
        .aboutus {
          display: block;
          height: 40px;
          li {
            float: left;
            margin-right: 30px;
            font-size: 14px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            a {
              display: block;
              font-weight: 400;
              font-size: 14px;
              color: #9ca3b2;
            }
          }
          li:first-child {
            margin-right: 72px;
            color: rgba(255, 255, 255, 1);
            span:first-child {
              vertical-align: middle;
              width: 6px;
              height: 6px;
              background: rgba(106, 152, 255, 1);
              display: inline-block;
              border-radius: 50%;
              margin-right: 6px;
            }
          }
        }
        .help {
          display: block;
          height: 40px;
          li {
            float: left;
            margin-right: 30px;
            font-size: 14px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            a {
              display: block;
              font-weight: 400;
              font-size: 14px;
              color: #9ca3b2;
            }
          }
          li:first-child {
            margin-right: 72px;
            color: rgba(255, 255, 255, 1);
            span:first-child {
              vertical-align: middle;
              width: 6px;
              height: 6px;
              background: rgba(106, 152, 255, 1);
              display: inline-block;
              border-radius: 50%;
              margin-right: 6px;
            }
          }
        }
      }
      .foot_r {
        .footer-right {
          margin-top: 80px;
        }
        .telphone {
          margin-right: 18px;
          img {
            width: 48px;
            height: 48px;
          }
        }
        .phone_num {
          p:first-child {
            height: 29px;
            font-size: 24px;
            font-family: DIN-Medium;
            font-weight: 500;
            color: rgba(255, 255, 255, 1);
            line-height: 29px;
            text-align: right;
          }
          p:last-child {
            height: 17px;
            font-size: 12px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            color: #9ca3b2;
            line-height: 17px;
            text-align: right;
          }
        }
        .tip {
          height: 20px;
          line-height: 1;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: rgba(255, 255, 255, 1);
          margin-top: 15px;
          margin-left: 15px;
        }
      }
    }
    .line_copy {
      height: 41px;
      margin-top: 13px;
      .line {
        width: 100%;
        height: 1px;
        background: rgba(215, 215, 217, 1);
        opacity: 0.2;
      }
      .copy {
        text-align: center;
        height: 40px;
        font-size: 12px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: #8d96a6;
        line-height: 40px;
      }
    }
  }
}
</style>


